/**
 * Simple in-memory cache for API requests
 * Cache duration: 5 minutes (300000ms)
 */

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const cache = new Map();

/**
 * Generate cache key from URL and params
 */
const getCacheKey = (url, params = {}) => {
  const paramsString = JSON.stringify(params);
  return `${url}?${paramsString}`;
};

/**
 * Get cached response if available and not expired
 */
export const getCachedResponse = (url, params = {}) => {
  const key = getCacheKey(url, params);
  const cached = cache.get(key);
  
  if (!cached) return null;
  
  const now = Date.now();
  if (now - cached.timestamp > CACHE_DURATION) {
    cache.delete(key);
    return null;
  }
  
  return cached.data;
};

/**
 * Set cached response
 */
export const setCachedResponse = (url, params = {}, data) => {
  const key = getCacheKey(url, params);
  cache.set(key, {
    data,
    timestamp: Date.now(),
  });
};

/**
 * Clear cache for a specific URL pattern
 */
export const clearCache = (urlPattern) => {
  if (!urlPattern) {
    cache.clear();
    return;
  }
  
  for (const key of cache.keys()) {
    if (key.includes(urlPattern)) {
      cache.delete(key);
    }
  }
};

/**
 * Clear all cache
 */
export const clearAllCache = () => {
  cache.clear();
};

